import * as _ from 'underscore';

export class User {
   id:number;
   orgId:number;
   name:string;
   handle:string;
   email:string;
   password:string;
   role:UserRole;
   brandIds:number[];
   campaignIds:number[];
   isLocked:boolean;

   constructor(user?) {
      if (user) {
         this.id = user.id;
         this.orgId = user.orgId;
         this.name = user.name;
         this.handle = user.handle;
         this.email = user.email;
         this.role = user.role;
         this.brandIds = user.brandIds;
         this.campaignIds = user.campaignIds;
         this.isLocked = user.isLocked;
      }
   }

   get isCampaignUser() {
      if (this.userType) {
         return this.userType.requireCampaign;
      }
   }

   get userType() {
      if (this.role) {
         return _.findWhere(User.userTypes, {role: this.role});
      }
   }

   roleChanged() {
      this.brandIds = [];
      this.campaignIds = [];
   }

   static userTypes = [
      {
         role: 'SuperAdmin',
         label: 'Super Admin',
         requireCampaign: false,
         level: 3
      },
      {
         role: 'OrgAdmin',
         label: 'Organization Admin',
         requireCampaign: false,
         level: 2
      },
      {
         role: 'BrandManager',
         label: 'Brand Manager',
         requireCampaign: false,
         level: 1
      },
      {
         role: 'CampaignManager',
         label: 'Campaign Organizer',
         requireCampaign: true,
         level: 1
      },
      {
         role: 'EventManager',
         label: 'Event Manager',
         requireCampaign: true,
         level: 1
      },
      {
         role: 'ReportUser',
         label: 'Report User',
         requireCampaign: true,
         level: 1
      },
      {
         role: 'ReportAppUser',
         label: 'Report / App User',
         requireCampaign: true,
         level: 1
      },
      {
         role: 'AppUser',
         label: 'App User',
         requireCampaign: true,
         level: 1
      }
   ];

   static getPermissableUserTypes(role:UserRole) {
      if (!role) {
         return [];
      }

      let type = _.findWhere(this.userTypes, {role: role});

      return _.filter(this.userTypes, function (t) {
         return t.level <= type.level;
      });
   }
}

export type UserRole = 'SuperAdmin'|'OrgAdmin'|'BrandManager'|'CampaignManager'|'EventManager'|'ReportUser'|'ReportAppUser'|'AppUser';

export interface UserType {
   role:UserRole;
   label:string;
   requireCampaign:boolean;
   level:number;
}
